export const isVersionForGlobalPartner = (partnerId: string) => {
  return partnerId.startsWith('GP-')
}
